import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/college-storage-fee.jpg'),
    alt: 'college storage fee page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college storage fee page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>College</span> <span>Storage Fee for Students</span>',
  description:
    'Do You Need Additional Storage Space for Your College Essentials?Look no further! Our smart storage solution offers FREE storage for up to 6 months.',
  image: {
    url: '/images/v2/pages/main-pages/college-storage-fee/hero-image.jpg',
    alt: 'college storage fee page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Cheapest Storage' }
}

export const serviceTipsSectionContent = {
  title: 'How It Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Storage Now' },

  cards: [
    {
      id: 1,
      title: 'Schedule a Pickup',
      description:
        'Book a convenient pickup from your location. Our team will handle everything, including boxes, luggage, furniture, and other items.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/schedule-a-pickup.svg',
        alt: 'Schedule a Pickup'
      }
    },
    {
      id: 2,
      title: 'Safe Storage',
      description:
        'Your items are stored in our climate-controlled, secure facilities, ensuring their safety and protection until you need them.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/safe-storage.svg',
        alt: 'Safe Storage'
      }
    },
    {
      id: 3,
      title: 'Shipping Options',
      description:
        'When you’re ready, we deliver your stored items back to you or ship them to a new address, depending on your requirements.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/shipping-options.svg',
        alt: 'Shipping Options'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Secure College Storage Fee Options',

  articles: [
    {
      content: [
        {
          id: 1,
          description:
            "At ShipAndStorage, we offer competitive college storage prices tailored for students' needs. Our secure and convenient storage solutions provide peace of mind during breaks or moves. Experience flexible rental options and excellent customer service, ensuring a hassle-free experience while you focus on your studies and enjoy your college life."
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/secure-college-storage-fee-options.jpg',
        alt: 'Secure College Storage Fee Options'
      }
    }
  ]
}

export const whyWeSectionContent = {
  title: 'Why Choose Our College Storage Services?',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Storage',
      description:
        'College Storage Fee: Enjoy up to 6 months of free storage. After that, our college storage fee is only $10/month per box or luggage, making it the most affordable option for students.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/cost-effective-storage.svg',
        alt: 'Cost-Effective Storage'
      }
    },
    {
      id: 2,
      title: 'Convenient Pickup and Delivery',
      description:
        "We offer hassle-free pickup and delivery services. Simply pack your items, and we'll handle the rest. No need to worry about transporting your belongings to and from the storage facility.",
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/convenient-pickup-and-delivery.svg',
        alt: 'Convenient Pickup and Delivery'
      }
    },
    {
      id: 3,
      title: 'Secure and Reliable',
      description:
        'Our storage units are equipped with state-of-the-art security measures, including digital surveillance and key-coded entry systems, ensuring your items are safe and secure.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/secure-and-reliable.svg',
        alt: 'Secure and Reliable'
      }
    },
    {
      id: 4,
      title: 'Flexible Storage Options',
      description:
        'Whether you need short-term or long-term storage, our flexible plans cater to your needs. Store only what you need without committing to a full storage unit.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/flexible-storage-options.svg',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Benefits of Our College Storage Services',

  cards: [
    {
      id: 1,
      title: 'Hassle-Free Moving Process',
      description: 'With our services, we manage everything from pickup to delivery, reducing stress and saving time.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/hassle-free-moving-process.svg',
        alt: 'Hassle-Free Moving Process'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description:
        'All items are stored in climate-controlled, monitored spaces, ensuring they remain in perfect condition.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/secure-storage-facilities.svg',
        alt: 'Secure Storage Facilities'
      }
    },
    {
      id: 3,
      title: 'Customizable Solutions',
      description: 'Choose services that match your timeline and budget, with no unnecessary extras.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/customizable-solutions.svg',
        alt: 'Customizable Solutions'
      }
    },
    {
      id: 4,
      title: 'Expert Customer Support',
      description:
        'Our knowledgeable team is available to assist with any questions, providing a smooth and seamless experience.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/expert-customer-support.svg',
        alt: 'Expert Customer Support'
      }
    },
    {
      id: 5,
      title: 'Sustainability Commitment',
      description: 'We use eco-friendly packing materials and energy-efficient storage solutions.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/sustainability-commitment.svg',
        alt: 'Sustainability Commitment'
      }
    },
    {
      id: 6,
      title: 'Pickup and Delivery Options',
      description:
        'Schedule pickups and deliveries at times that work best for your schedule, whether it’s same-day or planned.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/pickup-and-delivery-options.svg',
        alt: 'Pickup and Delivery Options'
      }
    }
  ]
}

export const advantageSectionContent = {
  title: 'Who Can Take Advantage of Our Services?',

  cards: [
    {
      id: 1,
      title: 'College Students',
      description:
        'Ideal for summer breaks or study abroad. Let us store your dorm essentials while you focus on your studies.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/college-students.svg',
        alt: 'College Students'
      }
    },
    {
      id: 2,
      title: 'Frequent Travelers',
      description:
        'Store your belongings while you explore the world. Retrieve them anytime with our easy delivery service.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/frequent-travelers.svg',
        alt: 'Frequent Travelers'
      }
    },
    {
      id: 3,
      title: 'Homeowners',
      description: 'Whether renovating, moving, or downsizing, our services simplify storing your household items.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/homeowners.svg',
        alt: 'Homeowners'
      }
    },
    {
      id: 4,
      title: 'Businesses',
      description:
        'Companies can securely store equipment, files, and seasonal items, with flexible shipping & storage options.',
      image: {
        src: '/images/v2/pages/main-pages/college-storage-fee/businesses.svg',
        alt: 'Businesses'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Affordable College Storage Prices Available Now',
  description:
    'Affordable college storage prices available. Fast and secure solutions for storing your belongings during the school year.',
  image: {
    src: '/images/v2/pages/main-pages/college-storage-fee/promotional-banner-image.svg',
    alt: 'Affordable College Storage Prices Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions (FAQ)',

  questions: [
    {
      id: 1,
      question: 'How much does the college storage fee cost after the free period?',
      answer:
        'After the initial 6 months of free storage, the college storage fee is only $10 per month for each box or luggage.'
    },
    {
      id: 2,
      question: 'What items can I store?',
      answer:
        'You can store a wide range of items including dorm essentials, furniture, books, clothing, and more. However, we do not allow the storage of perishable foods, plants, flammable items, or hazardous materials.'
    },
    {
      id: 3,
      question: 'How do I schedule a pickup?',
      answer:
        'Scheduling a pickup is easy! Simply visit our website, enter your location details, and choose a convenient time for our team to collect your items.'
    },
    {
      id: 4,
      question: 'Are my items insured while in storage?',
      answer:
        'Yes, we offer insurance coverage for your stored items to ensure they are protected against any unforeseen events.'
    },
    {
      id: 5,
      question: 'Can I access my items while they are in storage?',
      answer:
        'Yes, you can request access to your items at any time. Just let us know in advance, and we will arrange for you to retrieve your belongings.'
    }
  ]
}
